export default __webpack_public_path__ + "static/media/icon-left.e67ddca2.svg";